import { Modal } from '@iwoca/orion';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import IwModal from './iwModal';
import { CLOSE_MODAL } from './Modals.actions';
import * as constants from './Modals.constants';
import { ModalIdTypes } from './Modals.types';
import SignDocumentsModalWrapperStyles from '../myAccount/funding/fundingSteps/signDocumentAction/signDocumentModals/SignDocumentModals.module.css';
import SignDocumentsActionModal from '../myAccount/funding/fundingSteps/signDocumentAction/signDocumentModals/signDocumentsActionModal/SignDocumentsActionModal';
import ViewSignedDocumentModal from '../myAccount/funding/fundingSteps/signDocumentAction/signDocumentModals/viewSignedDocumentModal/ViewSignedDocumentModal';
import ViewGuarantorAgreementModal from '../myAccount/funding/fundingSteps/signDocumentAction/viewGuarantorAgreementModal/ViewGuarantorAgreementModal';
import AddPaymentMethodModal from '../myAccount/modals/addPaymentMethodModal/AddPaymentMethodModal';
import EditPaymentMethodModal from '../myAccount/modals/editPaymentMethodModal/EditPaymentMethodModal';
import FallbackErrorModal from '../myAccount/modals/fallbackErrorModal/FallbackErrorModal';
import FallbackErrorModalWrapperStyles from '../myAccount/modals/fallbackErrorModal/FallbackErrorModal.module.css';
import IdCheckVerificationModal from '../myAccount/modals/idCheckVerificationModal/IdCheckVerificationModal';
import LinkOpenBankingModal from '../myAccount/modals/linkOpenBankingModal/LinkOpenBankingModal';
import ManualPaymentModal from '../myAccount/modals/manualPaymentModal/ManualPaymentModal';
import PersonModal from '../myAccount/modals/personModal/PersonModal';
import ProcessingPaymentModal from '../myAccount/modals/processingPaymentModal/ProcessingPaymentModal';
import RepaymentScheduleModal from '../myAccount/modals/repaymentScheduleModal/RepaymentScheduleModal';
import TimeoutSessionErrorModal from '../myAccount/modals/timeoutSessionErrorModal/TimeoutSessionErrorModal';
import TimeoutSessionErrorModalWrapperStyles from '../myAccount/modals/timeoutSessionErrorModal/TimeoutSessionErrorModal.module.css';
import UploadDocumentsModal from '../myAccount/modals/uploadDocumentsModal/UploadDocumentsModal';
import HelpModal from '../myAccount/navigation/helpModal/HelpModal';

const mapStateToProps = ({ modals }: { modals: ModalIdTypes }) => modals;

const mapDispatchToProps = (dispatch: Dispatch) => ({
    closeModal: () => {
        dispatch({
            type: CLOSE_MODAL
        });
    }
});

type PropsFromRedux = ReturnType<typeof mapStateToProps> &
    ReturnType<typeof mapDispatchToProps>;

const IwModals = ({
    openModalId,
    errorModalId,
    errorModalError,
    closeModal
}: ModalIdTypes & PropsFromRedux) => {
    return (
        <>
            <IwModal
                isOpen={openModalId === constants.SIGN_DOCUMENTS_ACTION_MODAL}
                onClose={closeModal}
                contentStyles={SignDocumentsModalWrapperStyles.ModalWrapper}
            >
                <SignDocumentsActionModal />
            </IwModal>

            <IwModal
                isOpen={openModalId === constants.VIEW_SIGNED_DOCUMENTS_MODAL}
                onClose={closeModal}
                contentStyles={SignDocumentsModalWrapperStyles.ModalWrapper}
            >
                <ViewSignedDocumentModal />
            </IwModal>

            <IwModal
                isOpen={
                    openModalId === constants.VIEW_GUARANTOR_AGREEMENT_MODAL
                }
                onClose={closeModal}
            >
                <ViewGuarantorAgreementModal />
            </IwModal>

            <Modal
                isOpen={openModalId === constants.ADD_PAYMENT_METHOD_MODAL}
                onClose={closeModal}
                closeIcon
            >
                <AddPaymentMethodModal />
            </Modal>

            <Modal
                isOpen={openModalId === constants.EDIT_PAYMENT_METHOD_MODAL}
                onClose={closeModal}
                closeIcon
            >
                <EditPaymentMethodModal />
            </Modal>

            <IwModal
                isOpen={openModalId === constants.REPAYMENT_SCHEDULE_MODAL}
                onClose={closeModal}
            >
                <RepaymentScheduleModal />
            </IwModal>

            <IwModal
                isOpen={openModalId === constants.PERSON_MODAL}
                onClose={closeModal}
            >
                <PersonModal />
            </IwModal>

            <IwModal
                isOpen={openModalId === constants.PROCESSING_PAYMENT_MODAL}
                removeClose={true}
                onClose={closeModal}
            >
                <ProcessingPaymentModal />
            </IwModal>

            <IwModal
                isOpen={openModalId === constants.MANUAL_PAYMENT_MODAL}
                onClose={closeModal}
            >
                <ManualPaymentModal />
            </IwModal>

            <IwModal
                isOpen={errorModalId === constants.TIMEOUT_SESSION_ERROR_MODAL}
                removeClose={true}
                contentStyles={
                    TimeoutSessionErrorModalWrapperStyles.TimeoutSessionErrorModalWrapper
                }
            >
                <TimeoutSessionErrorModal />
            </IwModal>

            <IwModal
                isOpen={errorModalId === constants.FALLBACK_ERROR_MODAL}
                removeClose={true}
                contentStyles={
                    FallbackErrorModalWrapperStyles.FallbackErrorModalWrapper
                }
            >
                <FallbackErrorModal error={errorModalError} />
            </IwModal>

            <IwModal
                isOpen={openModalId === constants.UPLOAD_DOCUMENTS_MODAL}
                onClose={closeModal}
            >
                <UploadDocumentsModal />
            </IwModal>

            <IwModal
                isOpen={openModalId === constants.ONFIDO_VERIFICATION_MODAL}
                onClose={closeModal}
            >
                <IdCheckVerificationModal onClose={closeModal} />
            </IwModal>

            <IwModal
                isOpen={openModalId === constants.LINK_OPEN_BANKING_MODAL}
                removeClose={true}
                onClose={closeModal}
            >
                <LinkOpenBankingModal />
            </IwModal>

            <Modal
                isOpen={openModalId === constants.HELP_MODAL}
                onClose={closeModal}
                closeIcon
            >
                <HelpModal />
            </Modal>
        </>
    );
};

// eslint-disable-next-line import/no-default-export
export default connect(mapStateToProps, mapDispatchToProps)(IwModals);
